<template>
  <section class="form-section public-profile">
    <div class="row align-justify">
      <div class="small-12 columns">
        <ElForm
          ref="publicProfile"
          class="card"
          autocomplete="off"
          :model="publicProfileModel"
          :rules="rules"
          label-position="top"
          @submit.native.prevent="submitPublicProfileForm"
        >
          <div class="card__block">
            <ElFormItem class="is-fullwidth" prop="name_fa">
              <ElInput
                v-model="publicProfileModel.name_fa"
                type="text"
                name="name_fa"
                @input="verifyNameFa"
              />

              <template slot="label">
                {{ $t('DEVELOPER_TITLES.FA_TITLE') }}
                <a
                  class="public-profile__guidance-anchor"
                  @click="openModal('developerTitleGuidanceModal')"
                >
                  <i class="material-icons">
                    help_outline
                  </i>
                  {{ $t('AUTH.STEPS.PUBLIC_PROFILE.DEVELOPER_TITLE_GUIDANCE') }}
                </a>
              </template>

              <p class="el-form-item__help">
                <i class="el-icon-warning" />
                {{ $t('DEVELOPER_TITLES.NAME_INPUT_DESC') }}
              </p>
              <FieldError :errors="localErrors" field="name_fa" />
            </ElFormItem>

            <ElFormItem :label="$t('DEVELOPER_TITLES.FA_WEBSITE')">
              <ElInput
                v-model="publicProfileModel.website_fa"
                dir="ltr"
                type="text"
                name="website_fa"
                class="text-latin"
                placeholder="http://www.example.com/fa"
              />
              <FieldError :errors="localErrors" field="website_fa" />
            </ElFormItem>

            <ElFormItem :label="$t('DEVELOPER_TITLES.EN_TITLE')" prop="name_en">
              <ElInput
                v-model="publicProfileModel.name_en"
                dir="ltr"
                type="text"
                name="name_en"
                class="text-latin"
                @input="verifyNameEn"
              />

              <p class="el-form-item__help">
                <i class="el-icon-warning" />
                {{ $t('DEVELOPER_TITLES.NAME_INPUT_DESC') }}
              </p>
              <FieldError :errors="localErrors" field="name_en" />
            </ElFormItem>

            <ElFormItem :label="$t('DEVELOPER_TITLES.EN_WEBSITE')">
              <ElInput
                v-model="publicProfileModel.website_en"
                dir="ltr"
                type="text"
                name="website_en"
                class="text-latin"
                placeholder="http://www.example.com/en"
              />
              <FieldError :errors="localErrors" field="website_en" />
            </ElFormItem>

            <div class="auth-steps__navigation">
              <div />
              <ElButton type="primary" native-type="submit" :loading="loading">
                {{ $t('AUTH.STEPS.NEXT_LEVEL_BTN') }}
              </ElButton>
            </div>
          </div>

          <!-- dirty hack until ElementUI ends up with a solution -->
          <input v-show="false" type="submit" />
        </ElForm>
      </div>
    </div>
    <DeveloperTitleGuideModal v-model="developerTitleGuidanceModal" />
  </section>
</template>

<script>
import form from '@/mixins/form';
import modal from '@/mixins/modal';
import FieldError from '@@/common/FieldError';
import DeveloperTitleGuideModal from './modal/DeveloperTitleGuideModal';
import debounce from 'lodash.debounce';
import { Register } from '@/api/api';
import { requestQueue } from '@/api';

export default {
  name: 'PublicProfile',

  components: {
    FieldError,
    DeveloperTitleGuideModal,
  },

  mixins: [form, modal],

  props: {
    errors: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      publicProfileModel: {},
      developerTitleGuidanceModal: false,
      localErrors: this.getInitialLocalError(),
    };
  },

  computed: {
    rules() {
      const rules = {
        required: true,
        message: this.$t('VALIDATION_REQUIRED_ERR'),
        trigger: 'blur',
        type: 'string',
      };

      return {
        name_fa: rules,
        website_fa: rules,
        name_en: rules,
        website_en: rules,
      };
    },
    isThereAnyImportantError() {
      return this.localErrors.name_fa || this.localErrors.name_en;
    },
  },
  watch: {
    errors() {
      const initObject = this.getInitialLocalError();
      this.localErrors = { ...initObject, ...this.errors };
    },
  },
  methods: {
    submitPublicProfileForm() {
      if (!this.isValid('publicProfile') || this.isThereAnyImportantError) {
        return false;
      }
      this.$emit('submitPublicProfile', this.publicProfileModel);
    },
    debounceVerifier: debounce(function verifyByApiCall({ name, value }) {
      if (!value.trim()) return;
      const body = { [name]: value };
      requestQueue.flush();
      return Register.verifyDeveloperTitle({}, body)
        .then(({ body: { errors = {} } }) => {
          this.localErrors[name] = errors[name];
        })
        .catch(() => {});
    }, 500),
    verifyNameFa(value) {
      this.localErrors['name_fa'] = null;
      this.debounceVerifier({ name: 'name_fa', value });
    },
    verifyNameEn(value) {
      this.localErrors['name_en'] = null;
      this.debounceVerifier({ name: 'name_en', value });
    },
    getInitialLocalError() {
      return {
        name_fa: null,
        website_fa: null,
        name_en: null,
        website_en: null,
      };
    },
  },
};
</script>
<style lang="scss">
.public-profile {
  &__guidance-anchor {
    font-size: $small-font-size;
    float: right;

    @include rtl() {
      float: left;
    }

    i {
      font-size: 1rem;
    }
  }

  &__guidance-image {
    border-radius: 20px;
  }
}
</style>
